import {action, observable} from "mobx";
import {Permission} from "../model/Role";
import StoreState from "../model/StoreState";
import rolePermissionRepository from "../repository/RolePermissionRepository";

class RolePermissionListStore {
    @observable
    data: Permission[] = [];

    @observable
    state: StoreState = 'none';

    @action
    async load(clientId: string, roleId: string) {
        this.state = 'pending';
        try {
            const {data} = await rolePermissionRepository.find(clientId, roleId);
            this.data = data;
            this.state = 'done';
        } catch (e) {
            this.state = 'error';
            throw e;
        }
    }

    @action
    clear() {
        this.data = [];
        this.state = 'none';
    }
}

export default RolePermissionListStore;